import { ChangeEvent } from "react";

import { TextField } from "@material-ui/core";

export default function NameInput({
  value,
  onChange
}: {
  value: string | null;
  onChange: (name: string) => any;
}): JSX.Element {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    onChange(event.target.value);

  return (
    <TextField value={value || ""} onChange={handleChange} label="Field name" />
  );
}
